import { Badge } from "@/components/ui/Badge";
import {
  MZ_ORDER_STATUS_COLORS,
  MZ_ORDER_STATUS_LABELS,
  type MzOrderStatus,
} from "../../types";

export function MzStatusBadge({ status }: { status: MzOrderStatus }) {
  return (
    <Badge color={MZ_ORDER_STATUS_COLORS[status] ?? "gray"}>
      {MZ_ORDER_STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
